import { render, staticRenderFns } from "./UiAccordionItem.vue?vue&type=template&id=3f120070&scoped=true&"
import script from "./UiAccordionItem.vue?vue&type=script&lang=js&"
export * from "./UiAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./UiAccordionItem.vue?vue&type=style&index=0&id=3f120070&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f120070",
  null
  
)

export default component.exports